module.exports = "<span class=\"icon {{iconType}} {{iconState}}\"></span>";